import { render, staticRenderFns } from "./CategorySidebar.vue?vue&type=template&id=5d7ee165&scoped=true"
import script from "./CategorySidebar.vue?vue&type=script&lang=js"
export * from "./CategorySidebar.vue?vue&type=script&lang=js"
import style0 from "./CategorySidebar.vue?vue&type=style&index=0&id=5d7ee165&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7ee165",
  null
  
)

export default component.exports